import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { dsColorNew } from '@palette'
import { isLoadingCommonFilters } from '@signals'
import { BIAsked } from './@signals'


/** A search that failed stays on screen with Try again, not only a toast (CU-869fmk5ge, UX D3) */
export default function BISearchFailed() {
	if (BIAsked.value?.phase !== 'failed') return null

	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1.25, py: 8 }}>
		<Box sx={{ width: 48, height: 48, borderRadius: '12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: dsColorNew.dangerBg, color: dsColorNew.dangerRed }}>
			<IconSeeker icon="triangle-exclamation" sx={{ fontSize: 20 }}/>
		</Box>
		<Typography sx={{ fontSize: 16, fontWeight: 600, color: dsColorNew.textTitle }}>The search did not finish</Typography>
		<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted, maxWidth: 440 }}>
			Something went wrong on our side. Your question is kept above — try again.
		</Typography>
		<Button variant="outlined" sx={{ mt: 1, textTransform: 'none' }} onClick={() => { isLoadingCommonFilters.value = true }}>Try again</Button>
	</Box>
}
